var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"container"},[_c('v-btn',{attrs:{"color":"success","depressed":"","size":"small"},on:{"click":_vm.generatePDF}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-printer")]),_vm._v(" Rel. Requisição de Esterilizável ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }